import { RemoteKnowledgeRouteProps } from 'lib-knowledge-types';
import { config } from 'lib-shared-backend-config';
import { ComponentType, lazy } from 'react';

import { loadComponent } from 'utils/remoteComponent';

const url = getKnowledgeURL();
const scope = 'knowledge';

export const RemoteKnowledgeManagementRoutes = lazy<
  ComponentType<RemoteKnowledgeRouteProps>
>(loadComponent(scope, 'KnowledgeRoutes', url)); // KnowledgeRoutes to be renamed to KnowledgeManagementRoutes

export type RemoteKnowledgeHelpCenterRoutesProps = Omit<
  RemoteKnowledgeRouteProps,
  'featureFlags'
>;

export const RemoteKnowledgeHelpCenterRoutes = lazy<
  ComponentType<RemoteKnowledgeHelpCenterRoutesProps>
>(loadComponent(scope, 'KnowledgeHelpCenter', url));

function getKnowledgeURL(backendDomain = config.backendDomain): string {
  // NOTE: if you would like to test against a local instance of knowledge-fe uncomment the next line
  // return 'http://localhost:8082/remoteEntry.js';
  if (backendDomain?.includes('stag') || backendDomain?.includes('dev')) {
    return 'https://knowledge.stag.dixa.io/remoteEntry.js';
  }
  return 'https://knowledge.dixa.io/remoteEntry.js';
}
